// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610221205/js/" + chunkId + "." + {"44":"b6b1532c","225":"53c794d3","481":"7eaf4b73","486":"a3b56946","770":"4f951510"}[chunkId] + ".0.7159992525656966.chunk.js";
};